import { render, staticRenderFns } from "./AssignChargingStation.vue?vue&type=template&id=5a479320&scoped=true&"
import script from "./AssignChargingStation.vue?vue&type=script&lang=ts&"
export * from "./AssignChargingStation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a479320",
  null
  
)

export default component.exports